import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {TwoLine} from 'shells/two-line/two-line';
import {TwoLineButtonCard} from 'shells/two-line/two-line-button-card';

import type {SpamPreventionType} from 'nutshell-graphql-types';

import {
    getSpamPreventionDescription,
    getSpamPreventionIcon,
    getSpamPreventionTitle,
} from './helpers';

type Props = {
    spamPreventionType: SpamPreventionType;
    onClick: () => void;
};

export function SpamPreventionCard(props: Props) {
    return (
        <TwoLineButtonCard onClick={props.onClick}>
            <TwoLine
                icon={getSpamPreventionIcon(props.spamPreventionType)}
                iconSize={24}
                iconColor={colors.grey}
                topRow={getSpamPreventionTitle(props.spamPreventionType)}
                bottomRow={getSpamPreventionDescription(props.spamPreventionType)}
                isLargeWithSmallBottomRow={true}
                shouldCenterSingleLine={true}
            />
        </TwoLineButtonCard>
    );
}
